import { relaunchApi } from '@/logic/relaunchApi'

export function askPermission() {
  // Modern browsers: promise-based API
  return Notification.requestPermission().then((result) => {
    if (result !== 'granted') {
      throw new Error('Notification permission was denied.')
    }
  })
}
/**
   * urlBase64ToUint8Array
   *
   * @param {string} base64String a public valid key
   */
export function urlBase64ToUint8Array(base64String) {
  // eslint-disable-next-line no-mixed-operators
  const padding = '='.repeat((4 - base64String.length % 4) % 4)
  // eslint-disable-next-line no-useless-escape
  const base64 = (base64String + padding).replace(/\-/g, '+').replace(/_/g, '/')

  const rawData = window.atob(base64)
  const outputArray = new Uint8Array(rawData.length)

  for (let i = 0; i < rawData.length; ++i) {
    outputArray[i] = rawData.charCodeAt(i)
  }
  return outputArray
}

export async function updatePushNotification(body) {
  const response = await relaunchApi.post('/global/push-subscription', body)
  return response.data
}

export function subscribePushNotification() {
  return new Promise((resolve, reject) => {
    if (!navigator.serviceWorker?.controller) {
      reject(new Error('Service worker controller is not available'))
      return
    }
    navigator.serviceWorker.ready.then(async (serviceWorkerRegistration) => {
      if (!serviceWorkerRegistration) {
        reject(new Error('Service worker registration failed'))
        return
      }
      await askPermission()
      if (!process.env.VUE_APP_VAPID_PUBLIC_KEY) {
        reject(new Error('VAPID public key is not configured'))
        return
      }
      const existing = await serviceWorkerRegistration.pushManager.getSubscription()
      const subscription = existing
        ?? await serviceWorkerRegistration.pushManager.subscribe({
          userVisibleOnly: true,
          applicationServerKey: urlBase64ToUint8Array(process.env.VUE_APP_VAPID_PUBLIC_KEY),
        })
      await updatePushNotification(subscription)
      resolve()
    }).catch((err) => {
      reject(err)
    })
  })
}

export function removePushSubscriptions() {
  return new Promise((resolve, reject) => {
    const removeSubscription = async () => {
      try {
        await relaunchApi.delete('/global/push-subscription')
        resolve()
      } catch (err) {
        reject(err)
      }
    }

    // If there's no service worker, still try to notify backend
    if (!navigator.serviceWorker?.controller) {
      removeSubscription()
      return
    }

    navigator.serviceWorker.ready.then(async (serviceWorkerRegistration) => {
      if (!serviceWorkerRegistration) {
        removeSubscription()
        return
      }
      try {
        const subscription = await serviceWorkerRegistration.pushManager.getSubscription()
        if (subscription) {
          await subscription.unsubscribe()
        }
        removeSubscription()
      } catch (err) {
        reject(err)
      }
    }).catch((err) => {
      reject(err)
    })
  })
}
